import { render, staticRenderFns } from "./SelectProductsModal.vue?vue&type=template&id=308966e0&scoped=true&"
import script from "./SelectProductsModal.vue?vue&type=script&lang=js&"
export * from "./SelectProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308966e0",
  null
  
)

export default component.exports